<div class="container-fluid p-3">
  <div class="row">
    <div class="col-12 col-md-6">
      <div class="image-card">
        @if (property.ImageURLs) {
          <img class="property-image" [src]="property.ImageURLs + '&height=400'" />
        } @else {
          <app-no-content-banner bannerTitle="No Property Images Found" />
        }
      </div>
    </div>
    <div class="col-12 col-md-6">
      <pmx-overlay-map
        class="image-card"
        [center]="{
          lat: parseFloat(property.Latitude) || 0,
          lng: parseFloat(property.Longitude) || 0,
        }"
        [readOnly]="true"
      />
    </div>
  </div>

  <div class="row mt-4">
    <div class="col-9">
      <section class="d-flex align-items-center gap-4">
        <h2 class="m-0">
          {{ property.StreetAddress }}, {{ property.City }}, {{ property.StateOrProvince }} {{ property.PostalCode }}
        </h2>

        @if (property.PropertySubType) {
          <span class="proptype_pill"> {{ property.PropertySubType | enumRef: 'propertySubType' }} </span>
        }
      </section>

      <section class="prop_aments d-flex mt-5 mt-sm-3 w-100">
        <div class="me-4" matTooltip="Beds" matTooltipClass="prop_tooltip" matTooltipPosition="below">
          <img src="../assets/bed.svg" width="21px" class="me-2" />
          <span>
            {{ property.BedroomsTotal || property.PublicRecord?.BedroomsTotal | emptyData }}
          </span>
        </div>
        <div class="me-4" matTooltip="Baths" matTooltipPosition="below">
          <img src="../assets/bath.svg" width="21px" class="me-2" />
          <span>
            {{ property | bathroomDecimal: false }}
          </span>
        </div>
        <div class="me-4" matTooltip="Living area (Sqft)">
          <img src="../assets/livingarea.svg" width="21px" class="me-2" />
          <span>
            {{
              property.LivingArea || property.PublicRecord?.LivingArea | number: '1.0-0' | unitAffix: 'area' | emptyData
            }}
          </span>
        </div>
        <div class="me-4" matTooltip="Lot size (Sqft)">
          <img src="../assets/lotSize.svg" width="21px" class="me-2" />
          <span>
            {{
              property.LotSizeSquareFeet || property.PublicRecord?.LotSizeSquareFeet
                | number: '1.0-0'
                | unitAffix: 'area'
                | emptyData
            }}
          </span>
        </div>
      </section>
    </div>
    <div class="col-3 text-end">
      <p class="m-0">Last Sale Price</p>
      <h2>
        {{ property.ClosePrice | currency: 'USD' : 'symbol' : '1.0-0' }}
      </h2>
      <p>
        Sold On:
        <span> {{ property.CloseDate | simpleDate: true }} </span>
      </p>
    </div>
  </div>

  <div class="row g-0 my-3">
    <div class="col-4">
      <div class="review_key_dtls">
        <label>Owner Name</label>
        <p>{{ property.PublicRecord?.OwnerName || property.OwnerName | emptyData }}</p>
      </div>
    </div>
    <div class="col-4">
      <div class="review_key_dtls">
        <label>MLS#</label>
        <p>{{ property.MLSListingNumber | emptyData }}</p>
      </div>
    </div>
    <div class="col-4">
      <div class="review_key_dtls">
        <label>Parcel#</label>
        <p>
          {{ property.ParcelNumber || property.PublicRecord?.ParcelNumber | emptyData }}
        </p>
      </div>
    </div>
  </div>
</div>
